import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { WidgetProps } from '@rjsf/utils';

export function CheckboxWidget(props: WidgetProps) {
  const { id, value, disabled, readonly, label, onChange, schema, onFocus } = props;

  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id={id}
        checked={value || false}
        disabled={disabled || readonly}
        onCheckedChange={(checked) => onChange(checked)}
        onFocus={() => onFocus?.(id, value)}
      />
      {label && (
        <Label
          htmlFor={id}
          className="text-foreground text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {label}
          {schema.description && (
            <span className="text-muted-foreground ml-1 text-xs">({schema.description})</span>
          )}
        </Label>
      )}
    </div>
  );
}
